module.exports = __webpack_public_path__ + "img/AccountDetailsTopPictureOffer.f9c2e2b8.png";